import {useState, useEffect} from 'react';
import {getCustomer, updateCustomer} from './endpoints.js';
import errorHandler from '../../../util/errorHandler.js';
import {removeTimeOffset} from '../../../util/date.js';

export default function useCustomer(customerId, t) {
    const [customer, setCustomer] = useState(null);

    useEffect(() => {
        setCustomer(null);
        getCustomer(customerId)
            .then((response) => response.data)
            .then((data) => {
                if (!data) return data;

                // remove timezone offset from incoming timestamps, since we don't
                // care about the timezone, instead we want to show the same date and time
                // regardless of the timezone of the browser (geo location of the client)
                for (const ag of data.articleGroups) {
                    ag.startDate = removeTimeOffset(ag.startDate);
                    ag.endDate = removeTimeOffset(ag.endDate);
                    ag.earliestDateLinkedToAG = removeTimeOffset(ag.earliestDateLinkedToAG);
                    ag.latestDateLinkedToAG = removeTimeOffset(ag.latestDateLinkedToAG);
                }

                for (const ewi of data.extraWorkItems) {
                    ewi.startDate = removeTimeOffset(ewi.startDate);
                    ewi.endDate = removeTimeOffset(ewi.endDate);
                    ewi.earliestDateLinkedToEWI = removeTimeOffset(ewi.earliestDateLinkedToEWI);
                    ewi.latestDateLinkedToEWI = removeTimeOffset(ewi.latestDateLinkedToEWI);
                }

                return data;
            })
            .then((data) => setCustomer(data))
            .catch((e) => errorHandler(e.response.data, true, t));
    }, [customerId]);

    return {
        customer,
        loading: customer == null,
        update: (updatedCustomer) => updateCustomer(updatedCustomer),
    };
}
